<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">

      <div class="backborder2" style="margin-bottom:20px;display:inline-block;width:100%">
        <div class="cz-mall-offers-add-model-left">
          <!-- 基础信息 -->
          <div class="cz-mall-offers-add-model">
            <div class="cz-mall-offers-add-title">基础信息设置</div>
            <el-form class="demo-form-inline" ref="query" :model="query" size="small">
              <el-form-item label="活动名称" label-width="120">
                <el-input v-model="create.name"></el-input>
              </el-form-item>
              <el-form-item label="活动时间" label-width="120">
                <el-date-picker v-model="create.validity" type="daterange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false"></el-date-picker>
              </el-form-item>
              <el-form-item label="活动类型" label-width="120">
                <el-select v-model="create.activetype" placeholder="请选择" @change="changeaddactivetype" class="myselect">
                  <el-option v-for="item in activetypelists" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="活动方式">
                <!-- {{ JSON.stringify(typelists) }} -->
                <el-select v-model="create.type" placeholder="请选择" label-width="120" class="myselect"
                  @change="changetypes">
                  <el-option v-for="item in typelists" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="是否允许叠加" class="myradio">
                <el-radio-group v-model="create.is_add" size="small">
                  <el-radio-button label="0">否</el-radio-button>
                  <el-radio-button label="1">是</el-radio-button>
                </el-radio-group>
                <div class="cz-mall-offers-add-model-warning">
                  <el-tooltip class="item" effect="dark" content="允许当前活动与其它活动同时使用" placement="top">
                    <div>?</div>
                  </el-tooltip>
                </div>
              </el-form-item> -->
              <el-form-item label="活动规则">
                <el-radio-group v-model="create.rule_type" @change="handleRuleTypeChange">
                  <el-radio :label="2">循环（例：每满¥50减¥5）</el-radio>
                  <el-radio :label="1">阶梯（例：满¥50减¥5）</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>

          <!-- 活动层级设置 -->
          <div class="cz-mall-offers-add-model">
            <div class="cz-mall-offers-add-title">
              层级信息设置
              <el-button v-if="create.rule_type == 1" type="warning" icon="el-icon-plus" size="mini" circle @click="addlevel"
                style="margin-left:2%"></el-button>
            </div>
            <OffersactiveLadder ref="ladderRef" :ruletype="create.rule_type" :activetype="create.type" />
            <!-- <div class="cz-mall-offers-add-model-level">
              <div class="cz-mall-offers-add-model-level-one">
                <div class="cz-mall-offers-add-model-level-buy">{{ create.localtitle1 }}</div>
                <div class="cz-mall-offers-add-model-level-derate">{{ create.localtitle2 }}</div>
                <div class="cz-mall-offers-add-model-level-isadd">{{ create.localtitle3 }}</div>
                <div class="cz-mall-offers-add-model-level-handle">{{ create.localtitle4 }}</div>
              </div>
              <div class="cz-mall-offers-add-model-level-one" v-for="(item, index) in create.locallevel" :key="index">
                <div class="cz-mall-offers-add-model-level-buy"><el-input v-model="item.buy" type="text" size="small" />
                </div>
                <div class="cz-mall-offers-add-model-level-derate"><el-input v-model="item.derate" type="text"
                    size="small" /></div>
                <div class="cz-mall-offers-add-model-level-isadd">
                  <div style="display:flex;align-items:center;">
                    <el-input v-model="item.addmoney" type="text" size="small" style="width:100px;" />
                    <el-tooltip placement="top">
                      <div slot="content">
                        注：叠加次数为活动层级信息设置的优惠叠加次数；<br />
                        如：活动设置为买满5件赠送1件，并设置优惠叠加次数为2，<br />
                        买家下单购买数量为15件时，可赠送2件。
                      </div>
                      <div class="cz-mall-offers-add-model-level-isadd-notice">?</div>
                    </el-tooltip>
                  </div>
                </div>
                <div class="cz-mall-offers-add-model-level-handle"><el-button type="" size="small" round
                    @click="dellevel(index)">删除</el-button></div>
              </div>
              <div class="cz-mall-offers-add-model-level-no" v-if="create.locallevel.length == 0">
                <img src="../../assets/offers_level.png" />
                <span>您还没有添加层级</span>
              </div>
            </div> -->
          </div>
        </div>


        <div class="cz-mall-offers-add-model-right">
          <!-- 品牌/商品选择 -->
          <div class="cz-mall-offers-add-model">
            <div class="cz-mall-offers-add-title">
              活动范围
              <el-button type="warning" size="mini" icon="el-icon-plus" circle style="margin-left:2%"
                @click="selectgap('create', 'area')"></el-button>
              <div style="display:inline-block;margin-left:2%;font-size:13px;color:red;font-weight:normal;">已选中
                {{ create.param.length }} 个</div>
            </div>
            <div class="cz-mall-offers-add-goods-and-brands">
              <div class="cz-mall-offers-add-goods-and-brands-one" v-for="(item, index) in create.param" :key="index">
                <div class="cz-mall-offers-add-goods-and-brands-imgs">
                  <div class="cz-mall-offers-add-goods-and-brands-imgs-out">
                    <img :src="item.thumb == '' ? require('../../assets/default_img_mini.png') : item.thumb" />
                  </div>
                  <div class="cz-mall-offers-add-goods-and-brands-imgs-out-names">
                    <div class="cz-mall-offers-add-goods-and-brands-imgs-out-name">{{ item.name }}</div>
                  </div>
                </div>
                <div class="cz-mall-offers-add-goods-and-brands-ground">
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrant == 1">未授权</i>
                  <i class="sys-offers-details-brand-grant-yes" v-if="item.isgrant == 2">已授权</i>
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrant == 3">授权失败</i>
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrant == 4">授权未开始</i>
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrant == 5">授权到期</i>
                </div>
                <div class="cz-mall-offers-add-goods-and-brands-ground"
                  v-if="create.activetype == 1 || create.activetype == 3">
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrounding == 1">已下架</i>
                  <i class="sys-offers-details-brand-grant-yes" v-if="item.isgrounding == 0">已上架</i>
                </div>
                <div class="cz-mall-offers-add-goods-and-brands-del">
                  <el-button type="" size="small" round @click="delgoodsandbrand(index)">删除</el-button>
                </div>
              </div>
              <div class="cz-mall-offers-add-goods-and-brands-no" v-if="create.param.length == 0">
                <img src="../../assets/offers_cart.png" />
                <span>您还没有添加活动商品 / 品牌</span>
              </div>
            </div>
          </div>

          <!-- 赠品选择 -->
          <div class="cz-mall-offers-add-model" v-if="[2,3,7,8,9].includes(create.type)">
            <div class="cz-mall-offers-add-title">
              活动赠品
              <el-button type="warning" size="mini" icon="el-icon-plus" circle style="margin-left:2%"
                @click="selectgap('create', 'gifts')"></el-button>
              <!-- <el-button type="warning" size="mini" icon="el-icon-document" circle
                v-if="create.activetype == 1 || create.activetype == 3" @click="copygoodstogifts"></el-button> -->
              <div style="display:inline-block;margin-left:2%;font-size:13px;color:red;font-weight:normal;">已选中
                {{ create.localgifts.length }} 个</div>
            </div>
            <div class="cz-mall-offers-add-goods-and-brands">
              <div class="cz-mall-offers-add-goods-and-brands-one" v-for="(item, index) in create.localgifts"
                :key="index">
                <div class="cz-mall-offers-add-goods-and-brands-imgs">
                  <div class="cz-mall-offers-add-goods-and-brands-imgs-out">
                    <img :src="item.thumb == '' ? require('../../assets/default_img_mini.png') : item.thumb" />
                  </div>
                  <div class="cz-mall-offers-add-goods-and-brands-imgs-out-names">
                    <div class="cz-mall-offers-add-goods-and-brands-imgs-out-name">{{ item.name }}</div>
                  </div>
                </div>
                <div class="cz-mall-offers-add-goods-and-brands-ground">
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrant == 1">未授权</i>
                  <i class="sys-offers-details-brand-grant-yes" v-if="item.isgrant == 2">已授权</i>
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrant == 3">授权失败</i>
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrant == 4">授权未开始</i>
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrant == 5">授权到期</i>
                </div>
                <div class="cz-mall-offers-add-goods-and-brands-ground">
                  <i class="sys-offers-details-brand-grant-no" v-if="item.isgrounding == 1">已下架</i>
                  <i class="sys-offers-details-brand-grant-yes" v-if="item.isgrounding == 0">已上架</i>
                </div>
                <div class="cz-mall-offers-add-goods-and-brands-del">
                  <el-button type="" size="small" round @click="delgifts(index)">删除</el-button>
                </div>
              </div>
              <div class="cz-mall-offers-add-goods-and-brands-no" v-if="create.localgifts.length == 0">
                <img src="../../assets/offers_gifts.png" />
                <span>您还没有添加活动赠品</span>
              </div>
            </div>
          </div>
        </div>
        <div style="display:inline-block;width:calc(100% - 80px);margin-top:20px;padding:10px 40px;text-align:right;">
          <el-button type="primary" size="small" round :loading="addcreateLoading" @click="addcreateSave">保存</el-button>
        </div>
      </div>


      <!-- 选择商品/品牌信息 -->
      <el-dialog title="选择商品/品牌" :visible.sync="goodsbrandDialog" width="50%" top="10vh">

        <div class="cz-mall-offers-notice">温馨提示：商品、品牌活动只能选择已被审核通过的</div>
        <el-form :inline="true" class="demo-form-inline" size="small" style="margin-top:20px">
          <el-form-item v-if="goodsbrand.activetype == 1 || goodsbrand.activetype == 3">
            <el-select v-model="goodsbrand.brandid" placeholder="请选择品牌" @change="goodsbrand.ischange = true" filterable
              clearable>
              <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入关键字" v-model="goodsbrand.key" @keyup.enter.native="getgoodsorbrand"
              @change="goodsbrand.ischange = true" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getgoodsorbrand">查询</el-button>
          </el-form-item>
          <el-form-item>
            <div style="color:red;font-size:13px">已选择 {{ multipleSelection.length }} 个</div>
          </el-form-item>
        </el-form>

        <el-table :data="goodsbrandlists" v-loading="goodsbrand.loading" ref="multipleTable" tooltip-effect="dark"
          @row-click="selectrow" @select="handleSelectsingle" @select-all="handleSelectall">
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column label="ID" width="80">
            <template slot-scope="scope">
              <div class="cz-mall-offers-ID">{{ scope.row.id }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="商品/品牌信息">
            <template slot-scope="scope">
              <div class="cz-mall-offers-add-goods-and-brands-imgs-out" style="width:60px;height:60px">
                <img :src="scope.row.thumb == '' ? require('../../assets/default_img_mini.png') : scope.row.thumb" />
              </div>
              <div
                style="float:left;font-size:13px;line-height:23px;width:calc(100% - 62px - 10px);height:60px;margin-left:10px">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="是否授权" align="center" width="120">
            <template slot-scope="scope">
              <i class="sys-offers-details-brand-grant-no" v-if="scope.row.isgrant == 1">未授权</i>
              <i class="sys-offers-details-brand-grant-yes" v-if="scope.row.isgrant == 2">已授权</i>
              <i class="sys-offers-details-brand-grant-no" v-if="scope.row.isgrant == 3">授权失败</i>
              <i class="sys-offers-details-brand-grant-no" v-if="scope.row.isgrant == 4">授权未开始</i>
              <i class="sys-offers-details-brand-grant-no" v-if="scope.row.isgrant == 5">授权到期</i>
            </template>
          </el-table-column>
          <el-table-column label="上下架状态" key="isgrounding"
            v-if="goodsbrand.activetype == 1 || goodsbrand.activetype == 3" width="120">
            <template slot-scope="scope">
              <i class="sys-offers-details-brand-grant-no" v-if="scope.row.isgrounding == 1">已下架</i>
              <i class="sys-offers-details-brand-grant-yes" v-if="scope.row.isgrounding == 0">已上架</i>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="gobpageSizeChange" @current-change="gobpageCurrentChange"
            :current-page="goodsbrand.p" :page-sizes="[10, 20, 50]" :page-size="goodsbrand.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="goodsbrand.rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="goodsbrandDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="ensuregob">保存</el-button>
        </div>
      </el-dialog>

    </div>
  </transition>
</template>

<script>
import OffersactiveLadder from './OffersactiveLadder.vue';

export default {
  components: {
    OffersactiveLadder
  },  
  data() {
    return {
      url: this.GLOBAL.domain + "Offers/index",
      transitionshow: true,
      actionauth: '', //功能权限
      create: {
        act: 'add',
        token: this.$cookies.get('token'),
        name: '',
        validity: '',
        activetype: 1,
        rule_type: 2,
        type: 1,
        range: 1,
        is_add: '0',
        activeRule: '',
        localtitle1: '买满金额',
        localtitle2: '减少金额',
        localtitle3: '叠加次数',
        localtitle4: '操作',
        locallevel: [],
        localgifts: [],
        param: [],
        mjjj: [],
        mjss: [],
        mnss: [],
        msdz: [],
        mjdz: [],
        mjsj: [],
        msgoods: [],
        mngoods: [],
        applygoods: [],
      },
      activetypelists: [{ id: 1, name: '单品' }, { id: 2, name: '品牌' }, { id: 3, name: '混拼' }],
      typelists: [],
      brandlists: [],
      oldactivetype: 1,
      oldtype: 1,

      selectgobtype: '',
      selectgoblargess: '',
      goodsbrandDialog: false,
      goodsbrand: {
        act: 'selectgoodsorbrand',
        token: this.$cookies.get('token'),
        activetype: '',
        at: '',
        type: '',
        ids: '',
        brandid: '',
        key: '',
        p: 1,
        rollpage: 10,
        ischange: false,
        loading: false,
        rows: 0,
      },
      multipleSelection: [],
      goodsbrandlists: [],
      addcreateLoading: false,

    }
  },

  mounted() {
    this.getactionauth();
    this.gettypelists();
    this.getBrand();
  },

  methods: {
    handleRuleTypeChange() {
      this.$refs.ladderRef.changeRule()
    },
    /** 新增层级信息 **/
    addlevel() {
      // this.create.locallevel.push({ buy: '', derate: '', addmoney: '' });
      this.$refs.ladderRef.addLevel()
    },

    /** 保存活动信息 **/
    addcreateSave() {
      const levelJson = this.$refs.ladderRef.getData()
      console.log(levelJson, 'levelJson**********')
      if (this.create.rule_type == 1 && levelJson.length) {
        if (!levelJson.find(item => item.activity_display)) {
          this.$message.error('请勾选一个默认活动显示层级！');
          this.addcreateLoading = false;
          return
        }
      }
      this.addcreateLoading = true;
      var resource = this.$resource(this.url);
      var requestdata;
      requestdata = this.getrequestdata();
      requestdata.json_param = JSON.stringify(levelJson)

      resource.save(requestdata).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addcreateLoading = false;
        } else {
          this.$message.success('添加活动信息成功！');
          this.addcreateLoading = false;
          this.resetactiveinfos();
        }
      }).catch((res) => {
        this.addcreateLoading = false;
      });
    },

    /** 获取提交的活动信息 **/
    getrequestdata() {
      var _this = this;
      var request = {};
      var param = [];
      var gifts = [];
      
      request.act = this.create.act;
      request.token = this.create.token;
      request.name = this.create.name;
      request.validity = this.create.validity;
      request.activetype = this.create.activetype;
      request.type = this.create.type;
      request.range = this.create.range;
      request.is_add = this.create.is_add;
      request.rule_type = this.create.rule_type;

      this.create.param.forEach(function (item, i) {
        param.push(item.id);
      });
      request.param = JSON.stringify(param);
      if ([2,3,7,8,9].includes(this.create.type)) {
        this.create.localgifts.forEach(function (item, i) {
          gifts.push(item.id);
        });
        request.msgoods = JSON.stringify(gifts);
      }
      return request;
    },

    /** 重置活动信息 **/
    resetactiveinfos() {
      this.create.name = '';
      this.create.validity = '';
      this.create.activetype = 1;
      this.create.type = 1;
      this.create.range = 1;
      this.create.is_add = '0';
      this.create.localtitle1 = '买满金额';
      this.create.localtitle2 = '减少金额';
      this.create.localtitle3 = '叠加次数';
      this.create.localtitle4 = '操作';
      this.create.locallevel = [];
      this.create.localgifts = [];
      this.create.param = [];
      this.create.mjjj = [];
      this.create.mjss = [];
      this.create.mnss = [];
      this.create.msdz = [];
      this.create.mjdz = [];
      this.create.mjsj = [];
      this.create.msgoods = [];
      this.create.mngoods = [];
      this.create.applygoods = [];
      this.create.json_param = [];
      this.$refs.ladderRef.setData()
    },


    /** 将范围商品复制到赠品 **/
    copygoodstogifts() {
      this.$confirm('你是否要将活动范围内的商品作为活动赠品 ？', { type: 'warning' }).then(() => {
        this.create.localgifts = [];
        var _this = this;
        this.create.param.forEach(function (item, index) {
          _this.create.localgifts.push(item);
        });
      }).catch(() => {

      });
    },

    /** 删除赠品信息 **/
    delgifts(index) {
      this.$delete(this.create.localgifts, index);
    },

    /** 删除已选中的商品/品牌 **/
    delgoodsandbrand(index) {
      this.$delete(this.create.param, index);
    },

    /** 删除层级 **/
    dellevel(index) {
      this.$delete(this.create.locallevel, index);
    },

    /** 调整活动类型 **/
    changeaddactivetype() {
      this.$confirm('切换活动类型会将该类型下添加的商品或品牌、层级信息删除，您是否需要切换？', { type: 'warning' }).then(() => {
        this.create.locallevel = [];
        this.create.param = [];
        this.create.localgifts = [];
        this.oldactivetype = this.create.activetype;
        this.create.activetype == 2 ? this.create.range = 3 : this.create.range = 1;
      }).catch(() => {
        this.create.activetype = this.oldactivetype;
      });

    },

    /** 调整活动方式 **/
    changetypes() {
      this.$confirm('切换活动方式会将该类型下添加的商品或品牌、层级信息删除，您是否需要切换？', { type: 'warning' }).then(() => {
        this.create.locallevel = [];
        this.create.param = [];
        this.create.localgifts = [];
        this.oldtype = this.create.type;
        //修改活动层级表头信息
        this.changeparamtitle();
        this.$refs.ladderRef.changeRule()

      }).catch(() => {
        this.create.type = this.oldtype;
      });
    },

    /** 修改活动表头信息 **/
    changeparamtitle() {
      var type = this.create.type;
      var title1, title2, title3, title4;
      if (type == 1) {
        title1 = '买满金额'; title2 = '减少金额'; title3 = '叠加次数'; title4 = '操作';
      } else if (type == 2) {
        title1 = '买满金额'; title2 = '赠送数量'; title3 = '叠加次数'; title4 = '操作';
      } else if (type == 3) {
        title1 = '买满数量'; title2 = '赠送数量'; title3 = '叠加次数'; title4 = '操作';
      } else if (type == 4) {
        title1 = '买满数量'; title2 = '折扣（100%）'; title3 = '叠加次数'; title4 = '操作';
      } else if (type == 5) {
        title1 = '买满金额'; title2 = '折扣（100%）'; title3 = '叠加次数'; title4 = '操作';
      } else if (type == 6) {
        title1 = '买满金额'; title2 = '赠送金额'; title3 = '叠加次数'; title4 = '操作';
      }

      this.create.localtitle1 = title1;
      this.create.localtitle2 = title2;
      this.create.localtitle3 = title3;
      this.create.localtitle4 = title4;
    },


    /** 选择活动商品/品牌信息 **/
    selectgap(type, style) {
      this.selectgobtype = type;
      this.selectgoblargess = '';
      this.goodsbrand.activetype = this.create.activetype;
      this.goodsbrand.type = type;
      this.goodsbrand.at = style;
      this.goodsbrand.ids = [];
      this.goodsbrand.brandid = '';
      this.goodsbrand.key = '';
      this.goodsbrand.ischange = false;
      this.goodsbrand.rows = 0;
      this.goodsbrand.p = 1;
      this.goodsbrand.rollpage = 10;
      var _this = this;

      var data = style == 'area' ? this.create.param : this.create.localgifts;
      data.forEach(function (e, i) {
        if (e.id > 0) _this.goodsbrand.ids.push(e.id);
      });

      this.goodsbrandDialog = true;
      this.multipleSelection = []; //清空已选择的商品/品牌
      this.getgoodsorbrand();
    },

    /** 获取商品或品牌信息列表 **/
    getgoodsorbrand() {
      if (this.goodsbrand.ischange == true) {
        this.goodsbrand.p = 1;
        this.goodsbrand.rollpage = 10;
      }

      this.goodsbrand.loading = true;
      var resource = this.$resource(this.url);
      resource.save(this.goodsbrand).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.goodsbrand.loading = false;
        } else {
          var _this = this;
          var ids = [];
          var number = -1;
          this.goodsbrandlists = JSON.parse(Base64.decode(res.data.Data));
          this.goodsbrand.rows = parseInt(res.data.count);

          setTimeout(function () {
            _this.multipleSelection.forEach(function (item, index) { ids.push(item.id) });
            _this.goodsbrandlists.forEach(function (item, index) {
              number = ids.indexOf(item.id);
              if (number >= 0) _this.$refs.multipleTable.toggleRowSelection(item);
            });
          }, 200);

          this.goodsbrand.loading = false;
          if (this.goodsbrand.ischange == true) this.goodsbrand.ischange = false;
        }
      }).catch((res) => {
        this.goodsbrand.loading = false;
        if (this.goodsbrand.ischange == true) this.goodsbrand.ischange = false;
      });
    },
    gobpageSizeChange(val) {
      this.goodsbrand.rollpage = val;
      this.getgoodsorbrand();
    },
    gobpageCurrentChange(val) {
      this.goodsbrand.p = val;
      this.getgoodsorbrand();
    },


    /** 点击单行触发选择商品/品牌 **/
    selectrow(row, event, column) {
      var _this = this;
      var id = row.id;
      var ids = [];
      var number = -1;

      this.multipleSelection.forEach(function (item, index) { ids.push(item.id) });
      number = ids.indexOf(id);
      number == -1 ? this.multipleSelection.push(row) : this.$delete(this.multipleSelection, number);
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    /** 点击每行前面的选择框勾选/取消勾选商品 **/
    handleSelectsingle(val, row) {
      var _this = this;
      var id = row.id;
      var ids = [];
      var number = -1;

      this.multipleSelection.forEach(function (item, index) { ids.push(item.id) });
      number = ids.indexOf(id);
      number == -1 ? this.multipleSelection.push(row) : this.$delete(this.multipleSelection, number);
    },

    /** 点击选全部可见商品 **/
    handleSelectall(val) {
      var ids = [];
      var number = -1;
      var _this = this;

      this.multipleSelection.forEach(function (item, index) { ids.push(item.id) });
      if (val.length == 0) { //删除
        val.forEach(function (item, index) {
          number = ids.indexOf(item.id);
          if (number >= 0) {
            _this.$delete(ids, number);
            _this.$delete(_this.multipleSelection, number);
          }
        });

      } else { //新增
        val.forEach(function (item, index) {
          number = ids.indexOf(item.id);
          if (number == -1) {
            ids.push(item.id);
            _this.multipleSelection.push(item);
          }
        });

      }
    },

    /** 选择需要添加的商品或品牌 **/
    ensuregob() {
      var _this = this;
      var ids = [];
      var number = -1;
      var data = this.goodsbrand.at == 'area' ? this.create.param : this.create.localgifts;

      data.forEach(function (item, index) { ids.push(item.id) });
      this.multipleSelection.forEach(function (item, index) {
        number = ids.indexOf(item.id);
        if (number == -1 && _this.goodsbrand.at == 'area') _this.create.param.push(item);
        if (number == -1 && _this.goodsbrand.at == 'gifts') _this.create.localgifts.push(item);
      });
      this.goodsbrandDialog = false;
    },


    /** 获取功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取活动方式信息 **/
    gettypelists() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'gettype', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.typelists = JSON.parse(Base64.decode(res.data.Data));
          this.typelists.forEach(function (item, i) {
            item.id = Number(item.id);
          });
        }
      }).catch((res) => {

      });
    },


  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder3 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  float: left;
  width: 98%;
  padding: 1% 1% 0 1%;
}

.sys-offers-details-brand-grant-no {
  font-size: 12px;
  color: #fff;
  background: #909399;
  line-height: 12px;
  padding: 3px 0;
  border-radius: 15px;
  font-style: normal;
  text-align: center;
  margin-top: 5px;
  padding: 3px 10px
}

.sys-offers-details-brand-grant-yes {
  font-size: 12px;
  color: #fff;
  background: #67C23A;
  line-height: 12px;
  padding: 3px 0;
  border-radius: 15px;
  font-style: normal;
  text-align: center;
  margin-top: 5px;
  padding: 3px 10px
}

.cz-mall-offers-add-model {
  display: inline-block;
  width: 100%;
  margin-top: 20px
}

.cz-mall-offers-add-title {
  display: inline-block;
  width: calc(100% - 20px);
  font-size: 16px;
  font-weight: 550;
  padding: 10px 10px;
}

.cz-mall-offers-add-model .el-form-item__label {
  font-size: 13px
}

.cz-mall-offers-add-model .el-input {
  max-width: 55%
}

.cz-mall-offers-add-model .myselect .el-input {
  max-width: 100%
}

.cz-mall-offers-add-model .el-form {
  width: calc(100% - 20px);
  padding: 0 10px;
  margin-top: 20px;
}

.cz-mall-offers-add-handle {
  display: inline-block;
  width: calc(100% - 20px);
  padding: 0 10px;
  margin-top: 10px;
}

.cz-mall-offers-add-mode .myradio .el-form-item__content {
  max-width: 100%
}

.cz-mall-offers-add-model-warning {
  display: inline-block;
  margin-left: 10px
}

.cz-mall-offers-add-model-warning div {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #fff;
  background: #E6A23C;
  text-align: center;
  font-size: 12px;
  line-height: 12px;
}

.cz-mall-offers-add-model-level {
  display: inline-block;
  width: 100%;
  margin-top: 20px;
}

.cz-mall-offers-add-model-level-one {
  display: inline-block;
  width: 100%;
  font-size: 0;
}

.cz-mall-offers-add-model-level-no {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  font-size: 0;
}

.cz-mall-offers-add-model-level-no img {
  width: 25px;
  height: 25px;
}

.cz-mall-offers-add-model-level-no span {
  font-size: 14px;
  color: #999999;
  margin-left: 10px;
}

.cz-mall-offers-add-model-level-isadd-notice {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  font-size: 12px;
  line-height: 12px;
  color: #fff;
  background: #E6A23C;
  border-radius: 50%;
  margin-left: 10px;
}

.cz-mall-offers-add-model-level-buy {
  display: inline-block;
  text-align: center;
  padding: 10px 10px;
  font-size: 13px;
  line-height: 23px;
  width: calc(25% - 20px)
}

.cz-mall-offers-add-model-level-derate {
  display: inline-block;
  text-align: center;
  padding: 10px 10px;
  font-size: 13px;
  line-height: 23px;
  width: calc(25% - 20px)
}

.cz-mall-offers-add-model-level-isadd {
  display: inline-block;
  text-align: center;
  padding: 10px 10px;
  font-size: 13px;
  line-height: 23px;
  width: calc(25% - 20px)
}

.cz-mall-offers-add-model-level-handle {
  display: inline-block;
  text-align: center;
  padding: 10px 10px;
  font-size: 13px;
  line-height: 23px;
  width: calc(25% - 20px)
}

.cz-mall-offers-add-model-level-buy .el-input,
.cz-mall-offers-add-model-level-derate .el-input,
.cz-mall-offers-add-model-level-isadd .el-input,
.cz-mall-offers-add-model-level-handle .el-input {
  max-width: 100%
}

.cz-mall-offers-add-goods-and-brands {
  display: inline-block;
  width: calc(100% - 20px);
  margin-top: 20px;
  padding: 0 10px;
  height: 250px;
  overflow-y: auto;
}

.cz-mall-offers-add-goods-and-brands-one {
  display: inline-block;
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid #F2F6FC
}

.cz-mall-offers-add-goods-and-brands-imgs {
  float: left;
  width: calc(55% - 10px);
  height: 50px;
  padding: 0 10px 0 0;
}

.cz-mall-offers-add-goods-and-brands-imgs-out {
  float: left;
  width: 50px;
  height: 50px;
  border: 1px solid rgba(221, 221, 221, .7);
  background: rgba(221, 221, 221, .3);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center
}

.cz-mall-offers-add-goods-and-brands-imgs-out img {
  border-radius: 6px;
  max-width: 85%;
  max-height: 85%;
}

.cz-mall-offers-add-goods-and-brands-imgs-out-names {
  float: left;
  width: calc(100% - 72px);
  height: 50px;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cz-mall-offers-add-goods-and-brands-imgs-out-name {
  float: left;
  width: 100%;
  font-size: 13px;
  line-height: 21px;
  color: #606266
}

.cz-mall-offers-add-goods-and-brands-ground {
  float: left;
  width: 15%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cz-mall-offers-add-goods-and-brands-del {
  float: left;
  width: 15%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cz-mall-offers-add-goods-and-brands-no {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  padding: 10px 0;
}

.cz-mall-offers-add-goods-and-brands-no img {
  width: 25px;
  height: 25px;
}

.cz-mall-offers-add-goods-and-brands-no span {
  font-size: 14px;
  color: #999999;
  margin-left: 10px;
}


.cz-mall-offers-add-model-left {
  width: calc(48% - 30px);
  padding: 10px 30px 10px 0;
  float: left;
}

.cz-mall-offers-add-model-right {
  width: calc(48% - 30px);
  padding: 10px 0 10px 30px;
  float: left;
  border-left: 1px solid #EBEEF5;
  min-height: 600px;
}

.cz-mall-offers-notice {
  width: calc(100% - 20px);
  padding: 5px 10px;
  background: rgba(221, 221, 221, .5);
  border: 1px solid rgba(221, 221, 221, .7);
  border-radius: 6px;
  font-size: 12px;
  line-height: 23px;
  color: red;
}

.cz-mall-offers-ID {
  font-size: 13px
}
</style>


// WEBPACK FOOTER //
// src/components/mall/Offersactiveadd.vue